module.exports = __webpack_public_path__ + "static/og-image-ff4e106b17ef14b1146ab8a1511954ab.jpg";